export function getRandomIntInclusive(min: number, max: number): number {
  const minCeiled = Math.ceil(min);
  const maxFloored = Math.floor(max);
  return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled);
}

const FAKE_SCHEMAS: TranslationDetail[] = [
  // Manual submitted and translated and approved
  {
    translationRecordId: '',
    language: 'es',
    originalString: 'Medical Appointment',
    approvedValue: 'Cita Médica',
    translationReview: null,
    history: [
      {
        eventType: 'Approval',
        title: 'Approved by Natalia Reynolds',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: null,
        newValue: null
      },
      {
        eventType: 'Initial',
        title: 'Submitted by John Doe',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: 'Medical Appointment',
        newValue: 'Cita Médica'
      }
    ]
  },
  // Manual submitted and translated and approved
  {
    translationRecordId: '',
    language: 'es',
    originalString: 'Medical Appointment',
    approvedValue: 'Cita Médica',
    translationReview: {
      valueInReview: 'Medicación con context',
      date: '2025-01-01T12:00:00Z',
      changeReason: null,
      description: 'Edited by Robert JR',
      author: 'Robert JR'
    },
    history: [
    {
        eventType: 'Edit',
        title: 'Edited by Robert JR',
        date: '2025-01-01T06:00:00Z',
        changeReason: 'Just simple change',
        oldValue: 'Medicación',
        newValue: 'Medicación con context'
      },
      {
        eventType: 'Approval',
        title: 'Approved by Natalia Reynolds',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: null,
        newValue: null
      },
      {
        eventType: 'Initial',
        title: 'Submitted by John Doe',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: 'Medical Appointment',
        newValue: 'Cita Médica'
      }
    ]
  },
  // Manual submitted and translated and not approved
  {
    translationRecordId: '',
    language: 'es',
    originalString: 'I\'m ready to work',
    approvedValue: null,
      translationReview: {
    valueInReview: 'Estoy listo para trabajar',
    date: '2025-01-01T12:00:00Z',
    changeReason: null,
    description: 'Submitted by John Doe',
    author: 'John Doe',
  },
    history: [
      {
        eventType: 'Initial',
        title: 'Submitted by John Doe',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: 'I\'m ready to work',
        newValue: 'Estoy listo para trabajar'
      }
    ]
  },
  // AI submitted and by IA (not approved yet)
  {
    translationRecordId: '',
    language: 'es',
    originalString: 'Medication',
    approvedValue: null,
    translationReview: {
      valueInReview: 'Medicamento',
      date: '2025-01-01T12:00:00Z',
      changeReason: null,
      description: 'New string translated',
      author: 'Azure AI'
    },
    history: [
      {
        eventType: 'Initial',
        title: 'Translated into Spanish (ES) by Azure AI',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: 'Medication',
        newValue: 'Medicamento'
      }
    ]
  },
  // Manual submitted but translated by IA (not approved yet)
  {
    translationRecordId: '',
    language: 'es',
    originalString: 'Medication',
    approvedValue: null,
    translationReview: {
      valueInReview: 'Medicamento',
      date: '2025-01-01T12:00:00Z',
      changeReason: null,
      description: 'New string translated',
      author: 'Azure AI'
    },
    history: [
      {
        eventType: 'Initial',
        title: 'Submitted by John Doe',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: 'Medication',
        newValue: 'Medicamento'
      }
    ]
  },
  // Manual submitted but translated by IA (approved)
  {
    translationRecordId: '',
    language: 'es',
    originalString: 'Medication',
    approvedValue: 'Medicamento',
    translationReview: null,
    history: [
      {
        eventType: 'Approval',
        title: 'Approved by Natalia Reynolds',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: null,
        newValue: null
      },
      {
        eventType: 'Initial',
        title: 'Submitted by John Doe',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: 'Medication',
        newValue: 'Medicamento'
      }
    ]
  },
  // AI submitted and by IA (approved)
  {
    translationRecordId: '',
    language: 'es',
    originalString: 'Medication',
    approvedValue: 'Medicamento',
    translationReview: null,
    history: [
      {
        eventType: 'Approval',
        title: 'Approved by Natalia Reynolds',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: null,
        newValue: null
      },
      {
        eventType: 'Initial',
        title: 'Translated into Spanish (ES) by Azure AI',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: 'Medication',
        newValue: 'Medicamento'
      }
    ]
  },
  //deactivation
  {
    translationRecordId: '',
    language: 'es',
    originalString: 'Medication',
    approvedValue: 'Medicamento',
    translationReview: {
      valueInReview: 'Medicamento',
      date: '2025-01-01T12:00:00Z',
      changeReason: null,
      description: 'Reactivated by David',
      author: 'David'
    },
    history: [
      {
        eventType: 'Reactivation',
        title: 'Reactivation by David',
        date: '2025-01-01T06:00:00Z',
        changeReason: 'Reactivate because we already revised it',
        oldValue: 'Medicamento',
        newValue: 'Medicamento'
      },
      {
        eventType: 'Deactivation',
        title: 'Deactivation by David',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: null,
        newValue: null
      },
      {
        eventType: 'Approval',
        title: 'Approved by Natalia Reynolds',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: null,
        newValue: null
      },
      {
        eventType: 'Initial',
        title: 'Translated into Spanish (ES) by Azure AI',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: 'Medication',
        newValue: 'Medicamento'
      }
    ]
  },
  // AI submitted and by IA (approved) with some editions
  {
    translationRecordId: '',
    language: 'es',
    originalString: 'Medication',
    approvedValue: 'Medicamento',
    translationReview: null,
    history: [
      {
        eventType: 'Decline',
        title: 'Declined by Natalia Reynolds',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: null,
        newValue: null
      },
      {
        eventType: 'Edit',
        title: 'Edited by Robert JR',
        date: '2025-01-01T06:00:00Z',
        changeReason: 'Vibes *',
        oldValue: 'Medication',
        newValue: 'Medicación'
      },
      {
        eventType: 'Approval',
        title: 'Approved by Natalia Reynolds',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: null,
        newValue: null
      },
      {
        eventType: 'Initial',
        title: 'Translated into Spanish (ES) by Azure AI',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: 'Medication',
        newValue: 'Medicamento'
      }
    ]
  },
  {
    translationRecordId: '',
    language: 'es',
    originalString: 'Medication',
    approvedValue: 'Medicamento',
    translationReview: null,
    history: [
      {
        eventType: 'Decline',
        title: 'Declined by Natalia Reynolds',
        date: '2025-01-01T06:00:00Z',
        changeReason: 'This translation is not ok',
        oldValue: null,
        newValue: null
      },
      {
        eventType: 'Edit',
        title: 'Edited by Robert JR',
        date: '2025-01-01T06:00:00Z',
        changeReason: 'Vibes *',
        oldValue: 'Medication',
        newValue: 'Medicación'
      },
      {
        eventType: 'Approval',
        title: 'Approved by Natalia Reynolds',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: null,
        newValue: null
      },
      {
        eventType: 'Initial',
        title: 'Translated into Spanish (ES) by Azure AI',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: 'Medication',
        newValue: 'Medicamento'
      }
    ]
  },
  {
    translationRecordId: '',
    language: 'es',
    originalString: 'Medication',
    approvedValue: 'Vea los resultados de su laboratoiro explicados en contexto.',
    translationReview: null,
    history: [
      {
        eventType: 'Approval',
        title: 'Approved by Natalia Reynolds',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: null,
        newValue: null
      },
      {
        eventType: 'Edit',
        title: 'Edited by Natalia Reynolds',
        date: '2025-01-01T06:00:00Z',
        changeReason: 'Changed to prueba to laboratorio',
        oldValue: 'Vea sus resultados médicos explicados en contexto.',
        newValue: 'Vea los resultados de su laboratoiro explicados en contexto.'
      },
      {
        eventType: 'Decline',
        title: 'Declined by Natalia Reynolds',
        date: '2025-01-01T06:00:00Z',
        changeReason: 'We use ‘medicos’ not ‘prueba’ for lab in this context',
        oldValue: null,
        newValue: null
      },
      {
        eventType: 'Edit',
        title: 'Edited by Stephanie Kamras',
        date: '2025-01-01T06:00:00Z',
        changeReason: 'changed medicos to prueba',
        oldValue: 'Vea sus resultados médicos explicados en contexto.',
        newValue: 'Vea los resultados de su prueba explicados en contexto.'
      },
      {
        eventType: 'Approval',
        title: 'Approved by Greer Crow',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: null,
        newValue: null
      },
      {
        eventType: 'Initial',
        title: 'Translated into Spanish (ES) by Azure AI',
        date: '2025-01-01T06:00:00Z',
        changeReason: null,
        oldValue: 'See your lab results explained in context.',
        newValue: 'Vea sus resultados médicos explicados en contexto.'
      }
    ]
  }
]

function toTransCode(n: number): string {
  return `trans_${String(n).padStart(3, '0')}`;
}

export const TRANSLATION_DETAILS = Array.from(new Array(30), (_x, i) => {
  const index = getRandomIntInclusive(0, FAKE_SCHEMAS.length - 1)
  return {
    ...FAKE_SCHEMAS[index],
    translationRecordId: `${toTransCode(i)}`,
  }
})
